import { useQuery } from 'react-query';
import { useContext } from 'react';
import {
  communicationKeys,
  parseCommunicationKey,
} from '../../cache-keys/communicationKeys.tsx';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { email_api } from '@axo/shared/data-access/api';
import { queryFunction } from '../../query-function.ts';

export function useEmails(applicationID: string | undefined) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = communicationKeys.emails({
    applicationID,
  });

  return useQuery(
    cacheKey,
    queryFunction(
      email_api.findEmails(api),
      ({ queryKey }) => parseCommunicationKey(queryKey).applicationID
    ),
    {
      enabled: state.user.token.length > 0 && applicationID !== undefined,
    }
  );
}
